import React, { PropTypes } from 'react';

import { apiErrorPropType, organiserFullPropType } from '../../proptypes';

import Container from '../Container';
import LoadingEllipsis from '../LoadingEllipsis';
import OrganiserDetailPageMeta from './components/OrganiserDetailPageMeta';
import OrganiserDetail from '../OrganiserDetail';

import { container } from './styles.module.css';

/**
 * Organiser detail page presentational component.
 * Combines organiser detail component with loading and/or error components.
 **/
const OrganiserDetailPage = ({ fetching, error, organiser, searchQuery }) => {
  if (organiser) {
    return (
      <div>
        <OrganiserDetailPageMeta {...organiser} query={searchQuery} />
        <OrganiserDetail {...organiser} searchQuery={searchQuery} />
      </div>
    );
  }
  if (fetching) {
    return (
      <Container className={container}>
        <LoadingEllipsis htmlTag="h1" />
      </Container>
    );
  }
  return (
    <Container className={container}>
      <h1>{error && error.status === 404 ? 'Organiser not found' : 'Something went wrong'}</h1>
    </Container>
  );
};

OrganiserDetailPage.propTypes = {
  /**
   * Boolean describing current loading state.
   */
  fetching: PropTypes.bool,
  /**
   * Object representing current error state.
   */
  error: apiErrorPropType,
  /**
   * Organiser data object.
   */
  organiser: organiserFullPropType,
  /**
   * Query object for 'search' query.
  */
  searchQuery: PropTypes.shape(),
};

OrganiserDetailPage.defaultProps = {
  fetching: false,
  error: null,
  organiser: null,
  searchQuery: undefined,
};

export default OrganiserDetailPage;



// WEBPACK FOOTER //
// ./app/src/components/OrganiserDetailPage/index.jsx